import { getSize } from '@/utils/iterable/getSize';
import { get } from '@/utils/iterable/get';

import { PLACEHOLDERS } from '@/constants/forms';
import { ATTRIBUTE } from '@/constants/attributes';
import { AMOUNT } from '@/constants/product';
import { NONE } from '@/constants';
import { DATA } from '@/data';
import { EBAY } from '@/constants/channels';

function argOrArray(arg) {
  return arg || [];
}

function getTopCategories({ marketplaceId }) {
  return argOrArray(get([EBAY, marketplaceId, 'TAXONOMY', 'taxonomy', 'ids'])(DATA));
}

export function getCategoryIndex({ category, marketplaceId }) {
  return getSize(get([EBAY, marketplaceId, 'TAXONOMY', category, 'fullPath'])(DATA)) - 1;
}

export function getCategoryName({ category, marketplaceId }) {
  switch (category) {
    case AMOUNT.MINUS_ONE: {
      return NONE;
    }

    case AMOUNT.ZERO: {
      return PLACEHOLDERS[ATTRIBUTE.CATEGORY];
    }

    default: {
      return get([EBAY, marketplaceId, 'TAXONOMY', category, 'name'])(DATA) || '';
    }
  }
}

export function getCategoryPath({ category, marketplaceId }) {
  return argOrArray(get([EBAY, marketplaceId, 'TAXONOMY', category, 'fullPath'])(DATA));
}

export function getCategoryChildren({ category, marketplaceId }) {
  if (!category || category === AMOUNT.ZERO) {
    return getTopCategories({ marketplaceId });
  }

  const path = getCategoryPath({ category, marketplaceId });

  return argOrArray(get([EBAY, marketplaceId, 'TAXONOMY', 'taxonomy', ...path, 'ids'])(DATA));
}

export function getCategorySiblings({ category, marketplaceId }) {
  if (!category || category === AMOUNT.ZERO) {
    return getTopCategories({ marketplaceId });
  }

  const path = getCategoryPath({ category, marketplaceId });

  switch (getSize(path)) {
    case 0: {
      return [];
    }

    case 1: {
      return getTopCategories({ marketplaceId });
    }

    default: {
      return argOrArray(get([EBAY, marketplaceId, 'TAXONOMY', 'taxonomy', ...path.slice(0, -1), 'ids'])(DATA));
    }
  }
}

export function getParentCategory({ category, marketplaceId }) {
  return get([EBAY, marketplaceId, 'TAXONOMY', category, 'fullPath', 0])(DATA);
}

export function getCategoryProperty({ category, propertyName, marketplaceId }) {
  return get([EBAY, marketplaceId, 'CATEGORIES', category, 'properties', propertyName])(DATA);
}
